"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetSkeletonWrapper = void 0;
var _testidGenerator = require("@ori/testid-generator");
var _components = require("../../components");
var _constantsGenerated = require("../../constants-generated");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve --container */

const WidgetSkeletonWrapper = ({
  type,
  ...rest
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
  team: _testidGenerator.Team.Presentation,
  project: _constantsGenerated.APP_NAME,
  children: type === 'Gallery' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.GallerySkeleton, {
    ...rest
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SliderSkeleton, {
    ...rest
  })
});
exports.WidgetSkeletonWrapper = WidgetSkeletonWrapper;
